export default "__VITE_ASSET__8c932ebe__"